import styled from '@emotion/styled'

export const TnCParentDiv = styled.div`
  label: TnCParentDiv;
  color: ${(props) => props.theme.colors.textDarkblack};
  background-color: ${(props) => props.theme.backgrounds.backGround3};
  padding: 72px 0;
  ol {
    padding: 0;
    margin: 0;
    margin-left: 15px;
    li {
      strong {
        font-weight: 900;
      }
      margin-bottom: 18px;
    }
  }

  a {
    color: ${(props) => props.theme.colors.textDarkblack};
    font-weight: 900;
    text-decoration: underline;
  }
`
